module.exports = __webpack_public_path__ + "img/has-red-image.abc52149.png";